import * as ProjectConfig from 'Models/utils/project-config';

export default function generateIcon (iconName, isSymbol = false, isImg = false) {
    if (isSymbol) {
        let svgUrl = `${ProjectConfig.get('assetsUrl')}icons/symbols.svg`;
        const inlineSymbolSVGexists = document.querySelector('.symbol-svg');
        if (inlineSymbolSVGexists) svgUrl = '';
        return `<svg><use xlink:href="${svgUrl}#icon-${iconName}" /></svg>`;
    } else if (isImg) {
        const imgUrl = `${ProjectConfig.get('assetsUrl')}images/icons`;
        return `<img src="${imgUrl}/${iconName}.png">`;
    }
}
